// NotificationDropdown.jsx
import React, { useState, useEffect } from 'react';

const NotificationDropdown = () => {
  const [notifications, setNotifications] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        const response = await fetch('http://localhost:5000/api/notifications');
        if (!response.ok) {
          throw new Error(`Error: ${response.status} ${response.statusText}`);
        }
        const data = await response.json();
        setNotifications(Array.isArray(data) ? data : []);
      } catch (err) {
        console.error('Failed to fetch notifications:', err);
        setError('Failed to load notifications');
      }
    };

    fetchNotifications();
  }, []);

  // Compute header text and list items outside JSX to avoid complex inline expressions
  const headerText = error
    ? 'Failed to load notifications'
    : notifications.length > 0
    ? `You have ${notifications.length} new notifications`
    : 'No new notifications';

  const listItems = !error
    ? notifications.map((notification, index) => {
        const key = notification.id ?? index;
        const liClass = notification.className || 'notification-item';

        const content = notification.link ? (
          <a href={notification.link} className="notification-link">
            {notification.icon && <i className={`bi ${notification.icon}`} />}
            <div>
              <h4>{notification.title}</h4>
              <p>{notification.description}</p>
              <p>{notification.timestamp}</p>
            </div>
          </a>
        ) : (
          <button type="button" className="btn btn-link notification-link">
            {notification.icon && <i className={`bi ${notification.icon}`} />}
            <div>
              <h4>{notification.title}</h4>
              <p>{notification.description}</p>
              <p>{notification.timestamp}</p>
            </div>
          </button>
        );

        return (
          // each fragment returns two <li> so the list remains valid inside <ul>
          <React.Fragment key={key}>
            <li className={liClass}>{content}</li>
            <li>
              <hr className="dropdown-divider" />
            </li>
          </React.Fragment>
        );
      })
    : null;

  const footer = !error && notifications.length > 0 ? (
    <li className="dropdown-footer">
      <a href="/notifications">Show all notifications</a>
    </li>
  ) : null;

  return (
    <li className="nav-item dropdown">
      <button
        className="nav-link nav-icon btn btn-link position-relative"
        data-bs-toggle="dropdown"
        aria-expanded="false"
        aria-label="Toggle notifications"
        id="notificationDropdown"
      >
        <i className="bi bi-bell fs-5" />
        <span className="notification-badge">{notifications.length}</span>
      </button>

      <ul className="dropdown-menu dropdown-menu-end dropdown-menu-arrow" aria-labelledby="notificationDropdown">
        <li className="dropdown-header">{headerText}</li>

        <li>
          <hr className="dropdown-divider" />
        </li>

        {listItems}

        {footer}
      </ul>
    </li>
  );
};

export default NotificationDropdown;
